import React from "react";

const Java_Exceptions = () => {
  return (
    <div>
      <h1>Java Exceptions</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Exceptions in Java.</p>
    </div>
  );
};

export default Java_Exceptions;
